<div class="mosaic-slot-inner">
  @if (stream.error) {
    <div class="slot-state slot-error">
      <span class="material-icons">close</span>
    </div>
  } @else if (stream.camara) {
    <app-camera-player
      [idCamara]="stream.camara._id"
      [canal]="stream.canal"
      [fecha]="stream.recordDate"
      [mainStream]="mainStream"
    ></app-camera-player>
  }
</div>
